module.exports = __webpack_public_path__ + "static/media/trist.484cdf2e.m4a";